import api from './APIService';

class GeneralService {
    imageExist(url) {
        let img = new Image();
        img.src = url;
        return img.height != 0;
    }
    cleanImage(url, placeholder) {
        let img = new Image();
        img.src = url;
        let bandImg = img.height != 0;
        if(bandImg)
            return url;
        return placeholder;
    }
    getCountries() {
        return api.fetch({ method: 'get', path: '/setting/getCountries' });
	}
    getStates(country) {
        return api.fetch({ method: 'get', path: `/setting/getStates/${country}` });
	}
    getStatesCountries($data) {
        return api.fetch({ method: 'post', path: '/setting/getStates', data: $data });
    }
}

export default new GeneralService();